import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { Icon } from "@mqd/volt-core/src";
import { classes, useVoltState } from "@mqd/volt-toolbox/src";
import css from "./left-nav.module.css";
import { isLinkActive } from "./is-active.js";
export const LeftNavLink = forwardRef((props, ref) => {
  const {
    activePath,
    associatedPaths,
    nestedAssociatedPaths,
    children,
    go,
    path,
    onClick,
    content,
    contentId,
    icon,
    isActive: isActiveProp,
    ...linkProps
  } = props;
  const voltGo = useVoltState((state) => state.go);
  const [isActive, setIsActive] = React.useState(
    () => isLinkActive(props, activePath)
  );
  const handleOnClick = (event) => {
    if (path) {
      if (typeof go === "function") {
        event.preventDefault();
        go(path);
      } else if (typeof voltGo === "function") {
        event.preventDefault();
        voltGo(path);
      }
    }
    if (typeof onClick === "function")
      onClick(event);
  };
  React.useEffect(() => {
    if (!activePath)
      return;
    setIsActive(isLinkActive(props, activePath));
  }, [activePath]);
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      className: classes(css.leftNavLink, {
        [css["--active"]]: isActive
      }),
      href: path,
      ref,
      onClick: handleOnClick,
      "data-testid": `left-nav-link_${path}`,
      ...linkProps
    },
    children,
    icon && /* @__PURE__ */ React.createElement(
      Icon,
      {
        className: css.linkIcon,
        name: icon,
        color: isActive ? "var(--color-white)" : ""
      }
    )
  );
});
LeftNavLink.propTypes = {
  activePath: PropTypes.string,
  associatedPaths: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  content: PropTypes.any,
  icon: PropTypes.string,
  contentId: PropTypes.string,
  go: PropTypes.func,
  isActive: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  nestedAssociatedPaths: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func,
  path: PropTypes.string
};
LeftNavLink.defaultProps = {
  path: null
};
LeftNavLink.displayName = "LeftNav.NavLink";
